// This file was automatically generated from appchart.dialog.displayItem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.displayItem');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.ptdata.reports');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.displayItem.deletedOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pad10"><p class="el8ItalicText mb5">Document Date: ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''), '</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.displayItem.defaultContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DisplayDialogContainer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.displayItem.title = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.item.deleteDate) ? 'Deleted ' + ((opt_data.item.deleteUserName) ? 'by ' + soy.$$escapeHtml(opt_data.item.deleteUserName) + ' ' : '') + 'on ' + (soy.$$escapeHtml(opt_data.item.deleteDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.item.deleteDate)) : '') + ' - ' : '');
  switch (opt_data.item.modelClass) {
    case 'Report':
      el8.template.ptdata.reports.summary(opt_data.item, output);
      break;
    case 'VisitNote':
      el8.template.ptdata.model.note.visitNoteDescription(opt_data.item, output);
      break;
    case 'Letter':
      output.append('Letter - ', (soy.$$escapeHtml(opt_data.item.chartFeedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.item.chartFeedDate)) : ''));
      break;
    case 'LetterReceipt':
      output.append('Received Letter - ', (soy.$$escapeHtml(opt_data.item.chartFeedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.item.chartFeedDate)) : ''));
      break;
    case 'MessageThread':
      output.append('Office Message - ', (soy.$$escapeHtml(opt_data.item.chartFeedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.item.chartFeedDate)) : ''));
      break;
  }
  if (!opt_sb) return output.toString();
};
